<template>
  <div>
    <el-dialog :visible.sync="centerDialogVisible" width="590px" class="signin" center :modal-append-to-body='false'>
      <div class="content-box">
        <div class="title-img">
        </div>
        <div class="contentbox">
          <p class="title">{{SigninData.name}}</p>
          <p class="time" v-if="SigninData.forever== 0">{{signIn.actDet}}：{{SigninData.startTime |ftime}}-{{SigninData.endTime |ftime}}</p>
          <p class="time" v-if="SigninData.forever== 1">{{signIn.actDet}}：{{signIn.long}}</p>
          <p class="day" v-if="SigninData.signInRecordsVO && SigninData.signInRecordsVO.days">{{signIn.lianxu}}{{SigninData.signInRecordsVO.days}}天</p>
          <div>
            <el-scrollbar style="height:3.3rem;padding-right:2px" ref="refsBar">
              <ul class="ulbox">
                <li v-for="(item,i) of SigninData.signLevelData" :key="i" @click="onSigion(i)" ref="refsli">
                  <template v-if="i < SigninData.signInRecordsVO && SigninData.signInRecordsVO.days">
                  </template>
                  <template v-else>
                    <div>
                      <img loading="lazy" v-lazy="$common.getImgUrl(item.picUrl)" :class="{'shake':i == SigninData.signInRecordsVO.days && SigninData.signInRecordsVO.flag}" alt srcset />
                    </div>
                  </template>

                  <p class="monry">{{item.rewardSum}}元</p>
                  <p class="daynumber">第{{item.seriesDay}}天</p>
                </li>
              </ul>
            </el-scrollbar>

            <el-button round class="submitBtn" :disabled="!SigninData.signInRecordsVO.flag" @click="openReceive" v-if="SigninData.signInRecordsVO && SigninData.signInRecordsVO.flag">{{signIn.Signnow}}</el-button>
            <p class="tips" @click="openDetali">{{signIn.actDet}}</p>
          </div>
        </div>
      </div>
    </el-dialog>
    <detail ref="refdetail"></detail>
    <receive ref="refreceive" @onSignin="onSignin"></receive>
  </div>
</template>

<script>
import detail from './detail'
import receive from './receive'
export default {
  components: {
    detail,
    receive
  },
  props: {
    SigninData: Object
  },
  computed: {
    signIn() {
      return this.$t('signIn')
    }
  },
  filters: {
    ftime: function (value) {
      var date = new Date(value);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();

      // (formatNumber(date.getHours()));  
      // (formatNumber(date.getMinutes()));  
      // (formatNumber(date.getSeconds()));  
      return year + '.' + month + '.' + day;
    }
  },
  data() {
    return {
      centerDialogVisible: false
    };
  },
  watch: {
    SigninData(newValue, oldValue) {
      setImmediate(() => {
        if (this.SigninData.signInRecordsVO.days) {
          let hh = parseInt(this.SigninData.signInRecordsVO.days / 4);
          this.$refs.refsBar.wrap.scrollTop = (this.$refs.refsli[0].offsetHeight) * hh;
        }
      }, 300)
    }
  },
  created() {

  },
  methods: {
    onSigion(i) {
      if (i == this.SigninData.signInRecordsVO.days && this.SigninData.signInRecordsVO.flag) {
        this.openReceive()
      }
    },
    onclose() {
      this.centerDialogVisible = false;
    },
    openDetali() {
      this.$refs.refdetail.intro = this.SigninData.intro;
      this.$refs.refdetail.show = true;
    },
    openReceive() {

      let money = this.SigninData.signLevelData[this.SigninData.signInRecordsVO.days].rewardSum;
      let verityCount = this.SigninData.signLevelData[this.SigninData.signInRecordsVO.days].verityCount;
      this.$refs.refreceive.money = money;
      this.$refs.refreceive.verityCount = verityCount;
      this.$refs.refreceive.dialogVisible = true;
    },
    //领取
    onSignin() {
      let aid = this.SigninData.signLevelData[this.SigninData.signInRecordsVO.days].thematicActivitiesId;
      let userid = this.$common.getUser().user_id;
      this.$http
        .get(this.$api.signIn + "?memberId=" + userid + "&thematicActivitiesId=" + aid, "", true).then((res) => {
          if (res.code == 0) {
            // this.centerDialogVisible = false;
            this.RefreshData(this.SigninData.id)
            this.$message({
              message: "领取成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
    },
    RefreshData(id) {
      this.$http
        .get(this.$api.getThematicActivitiesByApp + "/" + id, "", true).then((res) => {
          if (res.code == 0) {
            this.SigninData = res.data;
          }
        });
    }
  },
};
</script>
<style>
.discount .el-dialog__headerbtn .el-dialog__close,
.discount .el-dialog__headerbtn .el-dialog__close:hover,
.signin .el-dialog__headerbtn .el-dialog__close,
.signin .el-dialog__headerbtn .el-dialog__close:hover {
  font-size: 30px !important;
  color: #fff;
  transition: 1s;
}
.discount .el-dialog__headerbtn .el-dialog__close:hover,
.signin .el-dialog__headerbtn .el-dialog__close:hover {
  transform: rotate(180deg);
}
</style>
<style lang="scss" scope>
.signin {
  .content-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title-img {
    // background-image: url("../../static/image/pn/signintitle.png");
    background-size: 100% auto;
    height: 2rem;
    text-align: right;
    width: 5.4rem;
    margin-left: 0.36rem;
    .close-img {
      width: 20px;
    }
  }
  .contentbox {
    // background-image: url("../../static/image/pn/signinbg.png");
    background-size: 100% 100%;
    text-align: center;
    min-height: 5.2rem;
    margin-top: -0.3rem;
    width: 4.56rem;
    .title {
      font-size: 0.2rem;
      color: #fff;
      padding-top: 0.05rem;
    }
    .time {
      color: #1d1717;
      font-size: 0.12rem;
      padding-top: 0.1rem;
    }
    .day {
      color: #1d1717;
      font-size: 0.18rem;
      padding-top: 0.05rem;
    }
    .ulbox {
      display: flex;
      padding: 0.16rem 0.37rem;
      min-height: 3.3rem;
      flex-wrap: wrap;
      overflow-y: scroll;
      li {
        margin-right: 0.19rem;
        text-align: center;
        margin-bottom: 0.24rem;
        width: 21.2%;
        height: 1.34rem;
        img {
          // width: 0.8rem;
          // height: 1.07rem;
        }
        .monry {
          color: #fff;
          font-size: 0.13rem;
          margin-top: -0.22rem;
          margin-bottom: 0.06rem;
          position: relative;
        }
        .daynumber {
          color: #1d1717;
          font-size: 0.15rem;
          margin-top: 0.12rem;
        }
      }
      li:nth-child(4n) {
        margin-right: 0px;
      }
    }
    .submitBtn {
      width: calc(100% - 1.12rem);
      margin: 0.24rem 0.56rem 0px 0.56rem;
      background: linear-gradient(
        90deg,
        rgba(255, 198, 45, 1) 0%,
        rgba(254, 197, 45, 1) 100%
      );
      box-shadow: 0px 3px 9px rgba(135, 51, 0, 0.06);
      opacity: 1;
      border-radius: 115px;
      border: none;
      color: #c74111;
    }
    .tips {
      color: #e5414a;
      font-size: 0.12rem;
      margin: 0px;
      padding: 0.08rem 0px;
      cursor: pointer;
    }
  }
  .el-dialog__body {
    background: transparent;
    padding: 0px 0.7rem;
  }
  .el-dialog {
    background: transparent;
    box-shadow: none;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #873300;
    cursor: not-allowed;
    background-image: none;
    background-color: #ffc62d;
    border-color: #ffc62d;
    opacity: 0.7;
  }
  @keyframes shake {
    0%,
    75% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(5deg);
    }
    100% {
      transform: rotate(-5deg);
    }
  }

  .shake {
    transform-origin: 50% 90%;
    animation: shake 0.5s linear 0s infinite alternate;
  }
}
</style>